import axios from 'axios';
import { DELETE_STEP } from '../paths';

export const deleteStep = async (courseStepID) => {
  await axios.post(DELETE_STEP, { courseStepID });
};
